import { IFieldDef } from "./FieldInfo";

const CollapsedGroupPrefix = "##CollapsedGroup##";
// Collapsed groups are bound to particular fields, so we need some unique generated ID which
// relates to the field, they are bound to.
export function getCollapsedGroupId(def: IFieldDef | string): string {
    const id = typeof def === "string" ? def : def.id;
    return `${CollapsedGroupPrefix}${id}`;
}